import { __, invertObj, prop } from 'ramda';

import { REGION } from '../../../types/filters';
import { INTERNATIONAL } from '../../../types/filters/region';

export const PRISMIC_TO_TYPE_REGION = {
  'Auvergne Rhône Alpes': REGION.AUVERGNE,
  'Bourgogne Franche Comté': REGION.BOURGOGNE,
  Bretagne: REGION.BRETAGNE,
  'Centre Val de Loire': REGION.CENTRE,
  Corse: REGION.CORSE,
  DOM: REGION.DOM,
  'Grand Est': REGION.GRAND_EST,
  'Hauts de France': REGION.HAUTS_DE_FRANCE,
  'Ile de France': REGION.ILE_DE_FRANCE,
  National: REGION.NATIONAL,
  Normandie: REGION.NORMANDIE,
  'Nouvelle Aquitaine': REGION.NOUVELLE_AQUITAINE,
  Occitanie: REGION.OCCITANIE,
  'Pays de la Loire': REGION.PAYS_DE_LA_LOIRE,
  "Provence Alpes Côte d'Azur": REGION.PACA,
  Afrique: REGION.AFRIQUE,
  Amériques: REGION.AMERIQUE,
  Asie: REGION.ASIE,
  Europe: REGION.EUROPE,
  Océanie: REGION.OCEANIE,
  International: INTERNATIONAL,
};

export const toRegionType = prop(__, PRISMIC_TO_TYPE_REGION);
export const toRegionPrismic = prop(__, invertObj(PRISMIC_TO_TYPE_REGION));
export const regionTypeDefault = () => REGION.NATIONAL;
